import { useEffect } from "react";
import { startOutboxDrain } from "@/features/assessment-v2/persistence";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Answers never get lost quietly.
 *
 * Anything the discovery flow couldn't send yet sits in a local outbox. This
 * mounts app-wide, so a learner who leaves the flow — closed tab, lost signal,
 * a tap back to the dashboard — still has their answers pushed the moment the
 * app is open and online again. Renders nothing.
 */
export default function AnswerDrain() {
  const { user } = useAuth();
  useEffect(() => {
    if (!user) return;
    return startOutboxDrain();
  }, [user]);
  return null;
}
